import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from './Label.module.css';

type LabelProps = {
    children: ReactNode;
    subdued?: boolean;
};

const Label = ({ children, subdued = false }: LabelProps) => {
    return (
        <span
            className={classNames(styles.Root, { [styles.subdued]: subdued })}
        >
            {children}
        </span>
    );
};

export default Label;
